function OnDocumentReady ()
{
	$.getScript( "https://maps.googleapis.com/maps/api/js?key="+google_api_key+"&callback=initMap" );
}

function initMap() {

	  var map = new google.maps.Map(document.getElementById('map'), {
	  	center: {lat: 43.653226, lng: -79.383184},
	    zoom: 6
	  });
			  
	  if (navigator.geolocation) {
		  
	    var infoWindow = new google.maps.InfoWindow();
		  
	  	navigator.geolocation.getCurrentPosition(function(position) {
	            var pos = {
	              lat: position.coords.latitude,
	              lng: position.coords.longitude
	            };

	     map.setCenter(pos);
	     }, function() {
	            handleLocationError(true, infoWindow, map.getCenter());
	          });
	    } else {
	       // Browser doesn't support Geolocation
	      handleLocationError(false, infoWindow, map.getCenter());
	    }
		
		for (var i = 0; i < venues.length; i++) {

	    	var marker = new google.maps.Marker({
	        	  position: venues[i],
	          	  map: map
	        });
	    	
			google.maps.event.addListener(marker, 'click', (function(marker, i) {
	        	return function() {
	        	html = venues[i]["name"] + "<br>" + venues[i]["addressLine"]+ "<br>" + venues[i]["city"] + "<br><a href='/tickets_for_venue/" + venues[i]["id"] + "'>View tickets</a>";       	
	        	infoWindow.setContent(html);
	        	infoWindow.open(map, marker);
	        	}
	      	})(marker, i));
	    }	
	}    

function handleLocationError(browserHasGeolocation, infoWindow, pos) {
        infoWindow.setPosition(pos);
        infoWindow.setContent(browserHasGeolocation ?
                              'Error: The Geolocation service failed.' :
                              'Error: Your browser doesn\'t support geolocation.');
}
